// extracted by mini-css-extract-plugin
module.exports = {"card":"BarchartWidget_card__22CMC","chartArea":"BarchartWidget_chartArea__Fy3ej"};